module.exports = __webpack_public_path__ + "media/images/ic-arrow-up-branca-e99adfd090bc75e4727658262338c0c6.svg";